export default __webpack_public_path__ + "static/waxburr-af2b79c812a21899c33af8ac3e0203a2.png";